// Editorial dates stay fixed across builds and change only when reviewed.
// The URL is the 2021 Contentful guide's; this file now owns it so AI answers
// and search results that already cite it keep working.
const customTrophyCostGuide = {
  path: '/guides/how-much-does-a-custom-trophy-cost/',
  title: 'How Much Does a Custom Trophy Cost?',
  publishedDate: '2021-03-07',
  reviewedDate: '2026-10-29',
  reviewedDateLabel: 'October 29, 2026',
}

module.exports = { customTrophyCostGuide }
